module.exports = __webpack_public_path__ + "static/media/ramen-dark-pressed.8426a5b4.gif";